import React, { useEffect, useState, useContext } from "react";
import { collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../../utils/firebase";
import { getMyBookings, updateProperty } from "../../api/wordpress";
import { UserContext } from "../../contexts/user.context";
import PageLoader from "../../components/loaders/page-loader.component";
import { isArray } from "../../utils/functions";
import { toast } from "sonner";
import BookingListScreen from "./params/booking-list.screen";
import NoBookingsScreen from "./params/no-bookings.screen";

const MyBookingsScreen = () => {
  const { fsUser } = useContext(UserContext);
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const userId =fsUser?.uid;
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBookings = async () => {
    try {
      setLoading(true);
      const response = await getMyBookings(token, { escrow_tenant_email: fsUser.email });
      let arr = [];
      
      if (response.data) {
        if (!isArray(response.data)) {
          if (Number.isInteger(Number(Object.keys(response.data)[0]))) {
            arr = Object.keys(response.data).map((key) => response.data[key]);
          } else {
            arr[0] = response.data;
          }
        } else {
          arr = response.data;
        }

        arr.sort((a, b) => {
          const dateA = new Date(a.acf?.escrow_payment_date?.replace(" ", "T") || a.date || 0).getTime();
          const dateB = new Date(b.acf?.escrow_payment_date?.replace(" ", "T") || b.date || 0).getTime();
          return dateB - dateA; 
        });
      }
      setBookings(arr);
    } catch (error) {
      console.error("Failed to fetch bookings:", error);
      toast.error("We hit a snag loading your bookings.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "My Bookings";

    if (fsUser?.email) {
      fetchBookings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fsUser?.email]);

  const handleStatusChange = async (propertyId, newStatus) => {
    try {
      const paymentsRef = collection(db, "paymentEntries");
      const q = query(paymentsRef, where("userId", "==", userId));
      const querySnapshot = await getDocs(q);

      let matchingTx = null;
      let transactionDocId = null;

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        const fbPropertyId = data.metadata?.propertyId;
        console.log(`Checking transaction ${doc.id} with propertyId ${fbPropertyId} and escrowStatus ${data.escrowStatus}`);
        if (Number(fbPropertyId) === Number(propertyId) && data.escrowStatus === "Held") {
          matchingTx = data;
          transactionDocId = doc.id;
        }
      });
       console.log("Matching transaction:", matchingTx, "Doc ID:", transactionDocId);
      if (!matchingTx || !transactionDocId) {
        toast.error("Could not locate the active escrow transaction. Please contact support.");
        return; 
      }

      const ownerId = matchingTx.receiverID;
      const firebaseStatus = newStatus === "payout_ready" ? "Move_In_Confirmed" : "Disputed";

      const globalRef = doc(db, "paymentEntries", transactionDocId);
      await updateDoc(globalRef, { escrowStatus: firebaseStatus });

      const ownerTxRef = doc(db, `payments/${ownerId}/transactions/${transactionDocId}`);
      await updateDoc(ownerTxRef, { escrowStatus: firebaseStatus });

      const formData = new FormData();
      formData.append("id", propertyId);
      formData.append("escrow_status", newStatus);
      
      await updateProperty(token, formData);
      
      toast.success(newStatus === "payout_ready" 
        ? "Awesome! We'll initiate the payout to the owner." 
        : "Issue flagged. Support will reach out to you shortly."
      );
      
      fetchBookings();
    } catch (error) {
      console.error("Status update failed:", error);
      toast.error("Couldn't process your request. Check your connection or contact support.");
    }
  };

  return (
    <div className="w-full pb-20">
      {loading ? (
        <div className="flex justify-center py-20">
          <PageLoader size="150px" />
        </div>
      ) : bookings.length > 0 ? (
        <BookingListScreen bookings={bookings} onStatusChange={handleStatusChange} />
      ) : (
        <NoBookingsScreen />
      )}
    </div>
  );
};

export default MyBookingsScreen;